export const discPages = [
  {
    page: 1,
    options: [
      { text: "Confiado, positivo", type: "I" },
      { text: "Argumentativo, habla sin rodeos", type: "D" },
      { text: "Dispuesto, bondadoso", type: "S" },
      { text: "Exacto, preciso", type: "C" },
    ],
  },
  {
    page: 2,
    options: [
      { text: "Optimista, de actitud positiva", type: "I" },
      { text: "Muestra iniciativa, quiere el cambio", type: "D" },
      { text: "Simpático, de fácil amistad", type: "S" },
      { text: "Meticuloso, cuidadoso", type: "C" },
    ],
  },
  {
    page: 3,
    options: [
      { text: "Sociable, hablador", type: "I" },
      { text: "Decidido, fuerte de voluntad", type: "D" },
      { text: "Gentil, amable", type: "S" },
      { text: "Diplomático, táctil", type: "C" },
    ],
  },
  {
    page: 4,
    options: [
      { text: "Convincente, persuasivo", type: "I" },
      { text: "Competitivo, jugador", type: "D" },
      { text: "Considerado, bondadoso", type: "S" },
      { text: "Consistente, predecible", type: "C" },
    ],
  },
  {
    page: 5,
    options: [
      { text: "Refrescante, estimulante", type: "I" },
      { text: "Aventurero, arriesgado", type: "D" },
      { text: "Respetuoso, considerado", type: "S" },
      { text: "Retraído, reservado", type: "C" },
    ],
  },
  {
    page: 6,
    options: [
      { text: "Vibrante, vivaz", type: "I" },
      { text: "Valiente, audaz", type: "D" },
      { text: "Comprensivo, bondadoso", type: "S" },
      { text: "Objetivo, justo", type: "C" },
    ],
  },
  {
    page: 7,
    options: [
      { text: "Valora la información, especialista", type: "C" },
      { text: "Orientado/a al trabajo en equipo", type: "S" },
      { text: "Temperamental, energético", type: "I" },
      { text: "Fácil de tratar, tolerante con otros", type: "S" },
    ],
  },
  {
    page: 8,
    options: [
      { text: "Animado, vivaz", type: "I" },
      { text: "Pionero, original", type: "D" },
      { text: "Planificado, organizado", type: "C" },
      { text: "Paciente, estable", type: "S" },
    ],
  },
  {
    page: 9,
    options: [
      { text: "Estimulante, inspirador", type: "I" },
      { text: "Independiente, individualista", type: "D" },
      { text: "Inofensivo, gentil", type: "S" },
      { text: "Imparcial, objetivo", type: "C" },
    ],
  },
  {
    page: 10,
    options: [
      { text: "Inquisitivo, observador", type: "C" },
      { text: "Amable, servicial", type: "S" },
      { text: "De férrea voluntad, orientado a metas", type: "D" },
      { text: "Alegre, de buen carácter", type: "I" },
    ],
  },
  {
    page: 11,
    options: [
      { text: "Humilde, seguidor", type: "S" },
      { text: "Tímido/a, cohibido/a", type: "C" },
      { text: "Seguro de sí mismo, intrépido", type: "D" },
      { text: "Entusiasta, que apoya", type: "I" },
    ],
  },
  {
    page: 12,
    options: [
      { text: "Enérgico, intransigente", type: "D" },
      { text: "Cree en las personas, buen orador", type: "I" },
      { text: "Comprensivo, compasivo", type: "S" },
      { text: "Tolerante, que acepta", type: "C" },
    ],
  },
  {
    page: 13,
    options: [
      { text: "Entretenido, ingenioso", type: "I" },
      { text: "Meticuloso, puntual", type: "C" },
      { text: "Duro/a, desafiante", type: "D" },
      { text: "Sereno, calmado", type: "S" },
    ],
  },
  {
    page: 14,
    options: [
      { text: "Disciplinado, auto-controlado", type: "C" },
      { text: "Vivaz, energético", type: "I" },
      { text: "Cooperativo, bien intencionado", type: "S" },
      { text: "No se rinde, fuerte", type: "D" },
    ],
  },
  {
    page: 15,
    options: [
      { text: "Confía, cree en las personas", type: "I" },
      { text: "Pacífico, satisfecho", type: "S" },
      { text: "Seguro de sí mismo, no deja lugar a dudas", type: "D" },
      { text: "Minucioso, callado", type: "C" },
    ],
  },
  {
    page: 16,
    options: [
      { text: "Ganador, competitivo", type: "D" },
      { text: "Sensible, solidario", type: "S" },
      { text: "Sociable, le gusta la compañía", type: "I" },
      { text: "Adaptable, complaciente", type: "C" },
    ],
  },
  {
    page: 17,
    options: [
      { text: "Voluntarioso, servicial", type: "S" },
      { text: "Ajustable, adaptable", type: "C" },
      { text: "Entusiasta, que no se opone", type: "I" },
      { text: "De vuelo alto, que confía en sí mismo", type: "D" },
    ],
  },
  {
    page: 18,
    options: [
      { text: "Seguidor, cumple instrucciones", type: "S" },
      { text: "Intrépido, recio", type: "D" },
      { text: "Encantador, animador", type: "I" },
      { text: "Fiel, responsable", type: "C" },
    ],
  },
  {
    page: 19,
    options: [
      { text: "Toma riesgos, seguro de sí mismo", type: "D" },
      { text: "Amistoso, abierto", type: "I" },
      { text: "Ajustable, flexible", type: "S" },
      { text: "Moderado, cauteloso", type: "C" },
    ],
  },
  {
    page: 20,
    options: [
      { text: "Conversador, extrovertido", type: "I" },
      { text: "Cohibido, moderado", type: "S" },
      { text: "Ordenado/a, tradicional", type: "C" },
      { text: "Inflexible, firme", type: "D" },
    ],
  },
  {
    page: 21,
    options: [
      { text: "Rápido, promotor de cambios", type: "D" },
      { text: "Confiable, predecible", type: "S" },
      { text: "Popular, agrada a todos", type: "I" },
      { text: "Bien organizado, minucioso", type: "C" },
    ],
  },
  {
    page: 22,
    options: [
      { text: "Persuasivo, convincente", type: "I" },
      { text: "Reservado, silencioso", type: "C" },
      { text: "Dócil, bondadoso", type: "S" },
      { text: "Individualista, con carácter", type: "D" },
    ],
  },
  {
    page: 23,
    options: [
      { text: "Conciliador, complaciente", type: "S" },
      { text: "Testarudo, inquebrantable", type: "D" },
      { text: "Encantador, agradable", type: "I" },
      { text: "Despierta simpatía, dulce", type: "C" },
    ],
  },
  {
    page: 24,
    options: [
      { text: "Responsable, obediente", type: "C" },
      { text: "Amable, cohibido", type: "S" },
      { text: "Ama la diversión, rebelde", type: "I" },
      { text: "Decidido, obstinado", type: "D" },
    ],
  },
];

export const discPagesEn = [
  {
    page: 1,
    options: [
      { text: "Confident, positive", type: "I" },
      { text: "Argumentative, blunt-spoken", type: "D" },
      { text: "Willing, kind-hearted", type: "S" },
      { text: "Accurate, precise", type: "C" }
    ]
  },
  {
    page: 2,
    options: [
      { text: "Optimistic, positive attitude", type: "I" },
      { text: "Shows initiative, wants change", type: "D" },
      { text: "Likeable, easy to befriend", type: "S" },
      { text: "Meticulous, careful", type: "C" }
    ]
  },
  {
    page: 3,
    options: [
      { text: "Sociable, talkative", type: "I" },
      { text: "Determined, strong-willed", type: "D" },
      { text: "Gentle, kind", type: "S" },
      { text: "Diplomatic, tactful", type: "C" }
    ]
  },
  {
    page: 4,
    options: [
      { text: "Convincing, persuasive", type: "I" },
      { text: "Competitive, a player", type: "D" },
      { text: "Considerate, kind", type: "S" },
      { text: "Consistent, predictable", type: "C" }
    ]
  },
  {
    page: 5,
    options: [
      { text: "Refreshing, stimulating", type: "I" },
      { text: "Adventurous, risk-taker", type: "D" },
      { text: "Respectful, considerate", type: "S" },
      { text: "Withdrawn, reserved", type: "C" }
    ]
  },
  {
    page: 6,
    options: [
      { text: "Vibrant, lively", type: "I" },
      { text: "Brave, bold", type: "D" },
      { text: "Understanding, kind-hearted", type: "S" },
      { text: "Objective, fair", type: "C" }
    ]
  },
  {
    page: 7,
    options: [
      { text: "Values information, specialist", type: "C" },
      { text: "Team-oriented", type: "S" },
      { text: "High-strung, energetic", type: "I" },
      { text: "Easy-going, tolerant of others", type: "S" }
    ]
  },
  {
    page: 8,
    options: [
      { text: "Lively, vivacious", type: "I" },
      { text: "Pioneer, original", type: "D" },
      { text: "Planned, organized", type: "C" },
      { text: "Patient, steady", type: "S" }
    ]
  },
  {
    page: 9,
    options: [
      { text: "Stimulating, inspiring", type: "I" },
      { text: "Independent, individualistic", type: "D" },
      { text: "Harmless, gentle", type: "S" },
      { text: "Impartial, objective", type: "C" }
    ]
  },
  {
    page: 10,
    options: [
      { text: "Inquisitive, observant", type: "C" },
      { text: "Friendly, helpful", type: "S" },
      { text: "Strong-willed, goal-oriented", type: "D" },
      { text: "Cheerful, good-natured", type: "I" }
    ]
  },
  {
    page: 11,
    options: [
      { text: "Humble, follower", type: "S" },
      { text: "Shy, timid", type: "C" },
      { text: "Self-confident, fearless", type: "D" },
      { text: "Enthusiastic, supportive", type: "I" }
    ]
  },
  {
    page: 12,
    options: [
      { text: "Energetic, uncompromising", type: "D" },
      { text: "Believes in people, good speaker", type: "I" },
      { text: "Understanding, compassionate", type: "S" },
      { text: "Tolerant, accepting", type: "C" }
    ]
  },
  {
    page: 13,
    options: [
      { text: "Entertaining, witty", type: "I" },
      { text: "Meticulous, punctual", type: "C" },
      { text: "Tough, challenging", type: "D" },
      { text: "Serene, calm", type: "S" }
    ]
  },
  {
    page: 14,
    options: [
      { text: "Disciplined, self-controlled", type: "C" },
      { text: "Vivacious, energetic", type: "I" },
      { text: "Cooperative, well-intentioned", type: "S" },
      { text: "Doesn't give up, strong", type: "D" }
    ]
  },
  {
    page: 15,
    options: [
      { text: "Trusting, believes in people", type: "I" },
      { text: "Peaceful, content", type: "S" },
      { text: "Self-assured, leaves no doubt", type: "D" },
      { text: "Thorough, quiet", type: "C" }
    ]
  },
  {
    page: 16,
    options: [
      { text: "Winner, competitive", type: "D" },
      { text: "Sensitive, supportive", type: "S" },
      { text: "Sociable, enjoys company", type: "I" },
      { text: "Adaptable, accommodating", type: "C" }
    ]
  },
  {
    page: 17,
    options: [
      { text: "Eager-to-help, service-minded", type: "S" },
      { text: "Adjustable, adaptable", type: "C" },
      { text: "Enthusiastic, agreeable", type: "I" },
      { text: "High-flying, self-confident", type: "D" }
    ]
  },
  {
    page: 18,
    options: [
      { text: "Follower, follows instructions", type: "S" },
      { text: "Fearless, tough", type: "D" },
      { text: "Charming, encouraging", type: "I" },
      { text: "Loyal, responsible", type: "C" }
    ]
  },
  {
    page: 19,
    options: [
      { text: "Risk-taking, self-assured", type: "D" },
      { text: "Friendly, open", type: "I" },
      { text: "Adjustable, flexible", type: "S" },
      { text: "Moderate, cautious", type: "C" }
    ]
  },
  {
    page: 20,
    options: [
      { text: "Talkative, outgoing", type: "I" },
      { text: "Reserved, moderate", type: "S" },
      { text: "Orderly, traditional", type: "C" },
      { text: "Inflexible, firm", type: "D" }
    ]
  },
  {
    page: 21,
    options: [
      { text: "Fast-paced, change agent", type: "D" },
      { text: "Reliable, predictable", type: "S" },
      { text: "Popular, liked by everyone", type: "I" },
      { text: "Well-organized, thorough", type: "C" }
    ]
  },
  {
    page: 22,
    options: [
      { text: "Persuasive, convincing", type: "I" },
      { text: "Reserved, quiet", type: "C" },
      { text: "Gentle, kind", type: "S" },
      { text: "Individualistic, strong-minded", type: "D" }
    ]
  },
  {
    page: 23,
    options: [
      { text: "Conciliatory, accommodating", type: "S" },
      { text: "Stubborn, unyielding", type: "D" },
      { text: "Charming, pleasant", type: "I" },
      { text: "Wins people over, sweet", type: "C" }
    ]
  },
  {
    page: 24,
    options: [
      { text: "Responsible, obedient", type: "C" },
      { text: "Kind, shy", type: "S" },
      { text: "Loves fun, rebellious", type: "I" },
      { text: "Determined, stubborn", type: "D" }
    ]
  }
];